import { render, staticRenderFns } from "./Threshold.vue?vue&type=template&id=ca4b54ac&scoped=true"
import script from "./Threshold.vue?vue&type=script&lang=js"
export * from "./Threshold.vue?vue&type=script&lang=js"
import style0 from "./Threshold.vue?vue&type=style&index=0&id=ca4b54ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4b54ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca4b54ac')) {
      api.createRecord('ca4b54ac', component.options)
    } else {
      api.reload('ca4b54ac', component.options)
    }
    module.hot.accept("./Threshold.vue?vue&type=template&id=ca4b54ac&scoped=true", function () {
      api.rerender('ca4b54ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/senior/Threshold.vue"
export default component.exports